export default __webpack_public_path__ + "static/media/berlin_impfbaer_dark.a8efb70e.png";